

// main

var layzr = new Layzr();
var userAgent = window.navigator.userAgent.toLowerCase();
var is_ie = (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) ? true : false;


$('.js-rotate3d').each(function() {
  rotate3d($(this));
});


$('a:not([href^="tel:"]):not([target])').on('click tap', function(e) {

  var ref = location.href;
  var url = $(this).attr('href');

  if( ref.indexOf(url.replace(/#.*$/, '')) != -1 && url.indexOf('#') != -1 ) {

    var speed = 300;
    var href= url.match(/#.*$/);
    var target = $(href[0]);
    var position = target.offset().top - $('.js-header').outerHeight();
    $('body, html').animate({ scrollTop: position }, speed, 'swing');
    return false;

  } else {

    e.preventDefault();
    url = $(this).attr('href');
    if (url !== '') {
      $('body').attr('data-status', 'loadstart');
      setTimeout(function() {
        window.location = url;
      }, 200);
    }
    return false;

  }

});

$('.js-accrodion-btn').on('click tap', function(e) {
  $(this).next('.js-accrodion-target').slideToggle();
  $(this).toggleClass('is-active');
});

var lock = false;
$('.js-menu-toggle').on('click tap', function() {
	if(lock) return;
  var $body = $('body');
	var $header = $('.js-header');
	var scrollBar_w = window.innerWidth - $(window).width();

	var status = $body.attr('data-menu');
  if( status == 'active' ) {
    lock = true;
		$body.attr('data-menu', '');
		$('#js-sp-menu').one('transitionend', function() {
			$(this).addClass('js-hide');
			$body.removeClass('js-hidden');
			$body.removeAttr('style');
			$header.removeAttr('style');
			lock = false;
		});
  } else {
		$('#js-sp-menu').removeClass('js-hide');
    $body.addClass('js-hidden').attr('data-menu', 'active');
		$body.css('paddingRight', scrollBar_w);
		$header.css('paddingRight', scrollBar_w);
  }
});

$('.p-pagetop').on('click tap', function() {
  $('body, html').animate({
    scrollTop: 0
  }, 300, 'swing');
});


$(window).on('load resize', function() {

  if( ($('.js-grid-col')[0] && $('.js-grid-col .js-grid-col-text')[0]) ) {
    $('.js-grid-col .js-grid-col-text').matchHeight();
  }

  set_liquid_font_size('.js-main-visual-copy-ttl-main', '.js-main-vusual-copy-parent', 11.8);
  set_liquid_font_size('.js-main-visual-copy-ttl-sub', '.js-main-vusual-copy-parent', 5.5);
});


$(window).on('load scroll', function() {

  if( $('.js-pagetop')[0] ) {
    var h = $(window).height();
    var scrollTop = $(window).scrollTop();
    if (scrollTop > h / 2) {
      $('.js-pagetop').addClass('is-active');
    }
    else {
      $('.js-pagetop').removeClass('is-active');
    }
  }

});


$(window).on('load', function() {

  if( location.hash && $(location.hash)[0] ) {

    var hash = location.hash;

    setTimeout( function() {
      $('body, html').animate({ scrollTop: $(hash).offset().top - $('.js-header').outerHeight() }, 0, 'linear');
    }, 300 );

    $('.p-gnav-link').each(function() {
      if(location.href.indexOf($(this).attr('href')) > 0) {
      $('.p-gnav-link').removeClass('is-active');
        $(this).addClass('is-active');
      }
    });

    if( $(location.hash).hasClass('js-accrodion-btn') ) {
      $(location.hash).trigger('click');
    }

  }

  loadContents();


	$('.js-mheight').matchHeight();
	$('.js-mheight2').matchHeight();
	$('.js-mheight3').matchHeight();
});


function is_mobile() {
  if (
    (navigator.userAgent.indexOf('iPhone') > 0 && navigator.userAgent.indexOf('iPad') == -1) ||
    navigator.userAgent.indexOf('iPod') > 0 ||
    navigator.userAgent.indexOf('Android') > 0
  ) {
    return true;
  }
  else {
    return false;
  }
}


function getParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[[]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


function loadContents() {

  var content_show_timeout = ( location.hash && $(location.hash)[0] ) ? 300 : 200;
  var animate_start_timeout = ( location.hash && $(location.hash)[0] ) ? 300 : 200;

  setTimeout(function() {

    $('body').attr('data-status', 'loaded');
		$('.l-loader').hide();

  }, content_show_timeout);

  setTimeout(function() {

    var timer = false;
    $(window).on('scroll', function () {

      eachAnimate();

      if( timer !== false ){
        clearTimeout( timer );
      }

      timer = setTimeout( function() {
        eachAnimate();
      }, 400 );

    });

    eachAnimate();
    setTimeout( function() {
      eachAnimate();
    }, 400 );

    if( $('.js-main-visual-slide')[0] && $('.swiper-slide').length > 1) {

      // eslint-disable-next-line no-undef
      var mainVisualSwiper = new Swiper('.js-main-visual-slide .swiper-container', {
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        loop: true,
        slidesPerView: 1,
        speed: 1000,
        autoplay: {
          delay: 3000,
        },
        noSwiping: true,
        on: {
          slideChange: function () {
            var mainTitle = $('.js-main-visual-ttl');
            var classList = this.slides[this.activeIndex].classList.value;
            mainTitle.removeClass('is-white');
            if (classList && classList.indexOf('swiper-slide-white') >= 0) {
              mainTitle.addClass('is-white');
            }
          },
        },
      });

    }

    if( $('.js-index-gallery-slider:not(.is-disabled)')[0] ) {
      var gallery_slider = $('.js-index-gallery-slider');
      var gallery_slider_item = gallery_slider.find('.js-index-gallery-slide-item'); 
      var gallery_slider_item_n = gallery_slider_item.length;
      var index_gallery_ticker_speed = 5000 * gallery_slider_item_n;
      var count = 0;
      gallery_slider.bxSlider({
        controls: false,
        ticker: true,
        slideWidth: 320,
        speed: index_gallery_ticker_speed,
      });

    }

    afterLoadFile('https://fonts.googleapis.com/css?family=Lato:400,700&display=swap', 'css');
    afterLoadFile('https://use.fontawesome.com/releases/v6.4.2/css/all.css', 'css');

  }, animate_start_timeout);

}


function rotate3d(elm) {
  elm
    .on('mouseenter', function(e) {
      $(this)
        .attr('data-hover', 'start')
        .delay(200)
        .queue(function(next) {
          $(this).attr('data-hover', 'end'); next();
        });
    })
    .on('mousemove', function(e) {
      var offset = $(this).offset();
      var ax = -( $(this).outerWidth() / 2 - (e.pageX - offset.left) ) / 15;
      var ay = ( $(this).outerHeight() / 2 - (e.pageY - offset.top) ) / 30;
      $(this).children().attr('style', 'transform: perspective(1000px) scale3d(1, 1, 1) rotateY('+ax+'deg) rotateX('+ay+'deg);-webkit-transform: perspective(1000px) scale3d(1, 1, 1) rotateY('+ax+'deg) rotateX('+ay+'deg);-moz-transform: perspective(1000px) scale3d(1, 1, 1) rotateY('+ax+'deg) rotateX('+ay+'deg)');
    })
    .on('mouseleave', function(e) {
      $(this).children().attr('style', 'transform: perspective(1000px) scale3d(1, 1, 1) rotateY(0deg) rotateX(0deg);-webkit-transform: perspective(1000px) scale3d(1, 1, 1) rotateY(0deg) rotateX(0deg);-moz-transform: perspective(1000px) scale3d(1, 1, 1) rotateY(0deg) rotateX(0deg)');
    });
}


function eachAnimate() {
  $('.js-animate').each(function () {
    var pos = $(this).offset().top;
    var h = $(window).height();
    var offset = ($(this).data('offset')) ? $(this).data('offset') : 200;
    var scrollTop = $(window).scrollTop() + offset;
    if (scrollTop > pos - h / 1.5) {
      $(this).addClass('is-active');
      $(this).removeClass('js-animate');
    }
  });
}


function afterLoadFile(src, type) {

  if( type == 'js' ) {
    $('body').append('<script src="'+src+'"></script>');
  }

  else if( type == 'css' ) {
    $('body').append('<link rel="stylesheet" href="'+src+'">');
  }

  else {
    return false;
  }

}


function set_liquid_font_size(elm, parent, size) {
  if (matchMedia('only screen and (min-width: 768px)').matches) {
    var h = $(parent).outerHeight();
    var percent = (h * (size / 100));
    $(elm).css('font-size', percent + 'px');
  } else {
    $(elm).removeAttr('style');
  }
}

